import * as React from "react";

import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "kb-avoid",
          "flex h-11 w-full rounded-lg border-2 border-input bg-background px-4 py-2.5 text-base ring-offset-background",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
          /* Placeholder com melhor contraste */
          "placeholder:text-muted-foreground/60 placeholder:font-normal",
          /* Transições suaves */
          "transition-all duration-200 ease-out",
          /* Estados de foco - mais definido */
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary",
          /* Hover - feedback visual */
          "hover:border-border/80",
          /* Disabled - mais claro */
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-muted/50",
          /* Active state */
          "active:scale-[0.99]",
          "md:text-sm",
          className,
        )}

        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };